/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { REMUNERATIONS: de },
  'el-GR': { REMUNERATIONS: el },
  'en-US': { REMUNERATIONS: en },
  'es-ES': { REMUNERATIONS: es },
  'fi-FI': { REMUNERATIONS: fi },
  'fr-FR': { REMUNERATIONS: fr },
  'it-IT': { REMUNERATIONS: it },
  'pl-PL': { REMUNERATIONS: pl },
  'pt-PT': { REMUNERATIONS: pt }
};
